import axios from "axios"
import CookieService from "./cookie"

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || "http://localhost:5001",
  headers: {
    "Content-Type": "application/json",
  },
})

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    const token = CookieService.getCookie("token")

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default apiClient
